import {SortTypeEnum} from 'constants/sortOrder'
import {EquipmentMatrixItem, EquipmentDictionaryRefs} from 'store/types'
import {FormEquipment} from 'pages/OperationalJournal/Logs/types'

export const ENUM_HEAD = {
  TIMESTAMP_KEY: 1,
  TIMESTAMP_VALUE: 'eventTimeAndDate',
  RECORD_TYPE_KEY: 2,
  RECORD_TYPE_VALUE: 'recordType',
  EQUIPMENT_KEY: 3,
  EQUIPMENT_VALUE: 'equipmentObjects',
  CREATED_BY_KEY: 4,
  CREATED_BY_VALUE: 'fullName',
  COMMENT_KEY: 5,
  COMMENT_VALUE: 'describeEvent',
}

export const headCells = [
  {
    key: ENUM_HEAD.TIMESTAMP_KEY,
    value: ENUM_HEAD.TIMESTAMP_VALUE,
  },
  {
    key: ENUM_HEAD.RECORD_TYPE_KEY,
    value: ENUM_HEAD.RECORD_TYPE_VALUE,
  },
  {
    key: ENUM_HEAD.EQUIPMENT_KEY,
    value: ENUM_HEAD.EQUIPMENT_VALUE,
  },
  {
    key: ENUM_HEAD.CREATED_BY_KEY,
    value: ENUM_HEAD.CREATED_BY_VALUE,
  },
  {
    key: ENUM_HEAD.COMMENT_KEY,
    value: ENUM_HEAD.COMMENT_VALUE,
  },
]

export const SORT_BY_MAP: Record<number, SortTypeEnum> = {
  [ENUM_HEAD.TIMESTAMP_KEY]: SortTypeEnum.CREATED_AT,
  [ENUM_HEAD.RECORD_TYPE_KEY]: SortTypeEnum.RECORD_TYPE,
  [ENUM_HEAD.EQUIPMENT_KEY]: SortTypeEnum.EQUIPMENT,
  [ENUM_HEAD.CREATED_BY_KEY]: SortTypeEnum.CREATED_BY,
}

export const fieldsConfig: Record<
  keyof FormEquipment,
  {matrixKey: keyof Omit<EquipmentMatrixItem, 'id'>; refKey: keyof EquipmentDictionaryRefs}
> = {
  voltageClassId: {matrixKey: 'vId', refKey: 'voltageClasses'},
  electricalSystemId: {matrixKey: 'iId', refKey: 'electricalSystems'},
  electricalConnectionId: {matrixKey: 'cId', refKey: 'electricalConnections'},
  typeNameId: {matrixKey: 'eId', refKey: 'equipmentTypes'},
  dispatcherNameId: {matrixKey: 'dId', refKey: 'dispatchNames'},
}

export const MULTI_SELECT_ITEM_SIZE = 52

export const MAX_EQUIPMENT_LENGTH = 20
export const COMMENT_TEXT_LIMIT = 500

export const OPTIONS_KEY = 'id'
export const OPTIONS_VALUE = 'name'
export const MAX_HOURS = 24
